import { render } from "./Tab4.vue?vue&type=template&id=2cd86b5c&ts=true"
import script from "./Tab4.vue?vue&type=script&lang=ts"
export * from "./Tab4.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__